import React, { JSX } from 'react';
import { IVATTypes } from '../../typings';

export const StepProgress: React.FC<{ steps: IVATTypes[]; currentStep: IVATTypes; }> = ({ steps = [], currentStep = 'vat_information' }) => {

  const stepsToRender: JSX.Element[] = [];
  for(const step of steps) {
    const index = steps.findIndex((s) => s === step) + 1;
    stepsToRender.push(<div key={step} className={`step-bullet ${step === currentStep ? 'active' : ''}`}>{index}</div>);
  }
  return (
    <div className="step-progress">
      <span className='steps-numof'>Step {steps.findIndex((s) => s === currentStep) + 1} of {steps.length}</span>
      <div className='steps-nums'>
        {stepsToRender.map((step) => (
          <>
            {step}
          </>
        ))}
      </div>
    </div>
  );
};
